export const pluralNounsFemFR: Array<string> = [
    'Abeilles',
    'Acquisitions',
    'Actions',
    'Activations',
    'Actrices',
    'Adaptations',
    'Administratrices',
    'Admissions',
    'Adolescentes',
    'Adresses',
    'Affaires',
    'Affiches',
    'Affirmations',
    'Agences',
    'Agricultures',
    'Aides',
    'Aiguilles',
    'Ailes',
    'Alarmes',
    'Alertes',
    'Alliances',
    'Allocations',
    'Allumettes',
    'Allures',
    'Alternatives',
    'Ambassades',
    'Ambitions',
    'Ambulances',
    'Ampleurs',
    'Analogies',
    'Analyses',
    'Ancres',
    'Animations',
    'Annonces',
    'Apparences',
    'Applications',
    'Approbations',
    'Approches',
    'Architectures',
    'Archives',
    'Armoires',
    'Arrestations',
    'Articulations',
    'Assiettes',
    'Assistances',
    'Associations',
    'Assurances',
    'Astuces',
    'Attaques',
    'Attentes',
    'Attitudes',
    'Attractions',
    'Aubes',
    'Audiences',
    'Autonomies',
    'Autorisations',
    'Autoroutes',
    'Aventures',
    'Baies',
    'Baignades',
    'Bananes',
    'Bandes',
    'Banlieues',
    'Banques',
    'Barres',
    'Batailles',
    'Biographies',
    'Blagues',
    'Blessures',
    'Boissons',
    'Boites',
    'Bottes',
    'Bouches',
    'Boucles',
    'Bougies',
    'Bouteilles',
    'Boutures',
    'Branches',
    'Briques',
    'Brosses',
    'Bulles',
    'Cabines',
    'Campagnes',
    'Candidatures',
    'Canettes',
    'Capitales',
    'Captures',
    'Carences',
    'Cargaisons',
    'Carottes',
    'Casquettes',
    'Casseroles',
    'Causes',
    'Cautions',
    'Ceintures',
    'Cellules',
    'Certitudes',
    'Chairs',
    'Chaises',
    'Chambres',
    'Chances',
    'Chansons',
    'Charges',
    'Chasses',
    'Chartes',
    'Chaussettes',
    'Chaussures',
    'Chemises',
    'Chevilles',
    'Chirurgies',
    'Choses',
    'Chutes',
    'Cibles',
    'Cigarettes',
    'Circulations',
    'Citations',
    'Civilisations',
    'Classes',
    'Clauses',
    'Clientes',
    'Cliniques',
    'Cloches',
    'Coalitions',
    'Collaborations',
    'Collectes',
    'Collections',
    'Collines',
    'Collisions',
    'Colonnes',
    'Combinaisons',
    'Commandes',
    'Commissions',
    'Communication',
    'Comparaisons',
    'Complications',
    'Compositions',
    'Concentrations',
    'Conceptions',
    'Concessions',
    'Conclusions',
    'Condamnations',
    'Conditions',
    'Conduites',
    'Confidences',
    'Configurations',
    'Confirmations',
    'Confitures',
    'Connaissances',
    'Connexions',
    'Conservations',
    'Consommations',
    'Constitutions',
    'Consultations',
    'Contradictions',
    'Contraintes',
    'Contributions',
    'Controverses',
    'Conventions',
    'Conversations',
    'Conversions',
    'Coordinations',
    'Copies',
    'Coquilles',
    'Cordes',
    'Cornes',
    'Corrections',
    'Correspondances',
    'Corruptions',
    'Couches',
    'Couleurs',
    'Coupes',
    'Courbes',
    'Couronnes',
    'Courses',
    'Courtoisies',
    'Couvertures',
    'Crises',
    'Critiques',
    'Croissances',
    'Croix',
    'Croyances',
    'Cuisines',
    'Cultures',
    'Cures',
    'Danses',
    'Demandes',
    'Dents',
    'Descentes',
    'Destinations',
    'Destructions',
    'Dettes',
    'Devises',
    'Diapositives',
    'Dimensions',
    'Directrices',
    'Dirigeantes',
    'Disciplines',
    'Dispositions',
    'Disputes',
    'Distances',
    'Distinctions',
    'Divisions',
    'Divulgations',
    'Doctrines',
    'Documentations',
    'Dominations',
    'Donatrices',
    'Douanes',
    'Douches',
    'Douleurs',
    'Eaux',
    'Embauches',
    'Encres',
    'Enfances',
    'Enseignantes',
    'Entrailles',
    'Entreprises',
    'Enveloppes',
    'Equipes',
    'Erreurs',
    'Espiones',
    'Essences',
    'Estimations',
    'Evasions',
    'Exceptions',
    'Excitations',
    'Exclusions',
    'Excuses',
    'Existences',
    'Expertises',
    'Expertes',
    'Explications',
    'Exploitations',
    'Explorations',
    'Explosions',
    'Exportations',
    'Expositions',
    'Expressions',
    'Extensions',
    'Factions',
    'Factures',
    'Faiblesses',
    'Falaises',
    'Familles',
    'Farines',
    'Faveurs',
    'Fermes',
    'Fermetures',
    'Feuilles',
    'Fibres',
    'Figures',
    'Filles',
    'Finales',
    'Finances',
    'Finitions',
    'Fins',
    'Fissures',
    'Flammes',
    'Fleurs',
    'Fonctions',
    'Fondations',
    'Fondatrices',
    'Forces',
    'Formations',
    'Formes',
    'Formules',
    'Fortunes',
    'Fosses',
    'Foules',
    'Fourches',
    'Fournitures',
    'Fourrures',
    'Fractions',
    'Franchises',
    'Fraudes',
    'Fuites',
    'Fusions',
    'Gagnantes',
    'Galeries',
    'Gammes',
    'Garanties',
    'Gares',
    'Gestions',
    'Glaces',
    'Gorges',
    'Gouttes',
    'Gouvernances',
    'Graines',
    'Graisses',
    'Grenouilles',
    'Grilles',
    'Grossesses',
    'Grottes',
    'Guerres',
    'Guitares',
    'Habitantes',
    'Habitudes',
    'Hanches',
    'Harmonies',
    'Herbes',
    'Heures',
    'Histoires',
    'Horloges',
    'Horreurs',
    'Huiles',
    'Humaines',
    'Humeurs',
    'Ignorances',
    'Illusions',
    'Illustrations',
    'Images',
    'Implications',
    'Importations',
    'Impressions',
    'Imprimantes',
    'Incertitudes',
    'Incitations',
    'Inclusions',
    'Indications',
    'Industries',
    'Infections',
    'Informations',
    'Infos',
    'Influences',
    'Infractions',
    'Infrastructures',
    'Initiatives',
    'Injections',
    'Injustices',
    'Inondations',
    'Inscriptions',
    'Insertions',
    'Inspirations',
    'Installations',
    'Instances',
    'Instructions',
    'Intellectuelles',
    'Intentions',
    'Interactions',
    'Interdictions',
    'Interfaces',
    'Interventions',
    'Inventions',
    'Invitations',
    'Jambes',
    'Joies',
    'Jonctions',
    'Joues',
    'Joueuses',
    'Jupes',
    'Juridictions',
    'Lacunes',
    'Laines',
    'Laiteries',
    'Lames',
    'Lampes',
    'Langues',
    'Larmes',
    'Lectures',
    'Lentilles',
    'Lettres',
    'Licences',
    'Ligues',
    'Limites',
    'Listes',
    'Livraisons',
    'Locations',
    'Logiques',
    'Lois',
    'Longueurs',
    'Loteries',
    'Louanges',
    'Lunes',
    'Lunettes',
    'Luttes',
    'Machines',
    'Magistrates',
    'Maintenances',
    'Maisons',
    'Manches',
    'Manifestations',
    'Manipulations',
    'Marchandises',
    'Marches',
    'Marges',
    'Marques',
    'Masses',
    'Mentions',
    'Mers',
    'Merveilles',
    'Mesures',
    'Migrations',
    'Mines',
    'Minutes',
    'Missions',
    'Modifications',
    'Monitrices',
    'Montagnes',
    'Morsures',
    'Motivations',
    'Mouches',
    'Moyennes',
    'Musiques',
    'Naissances',
    'Nations',
    'Navigatrices',
    'Neiges',
    'Niches',
    'Noisettes',
    'Normes',
    'Notes',
    'Notions',
    'Nouvelles',
    'Nuances',
    'Objections',
    'Obligations',
    'Observations',
    'Occasions',
    'Occurrences',
    'Odeurs',
    'Oeuvres',
    'Offres',
    'Ombres',
    'Oppositions',
    'Options',
    'Oranges',
    'Ordonnances',
    'Oreilles',
    'Organisations',
    'Organisatrices',
    'Orientations',
    'Origines',
    'Oscillations',
    'Ouvertures',
    'Pages',
    'Paires',
    'Pannes',
    'Parcelles',
    'Paroisses',
    'Participantes',
    'Participations',
    'Passions',
    'Patientes',
    'Patries',
    'Patrouilles',
    'Pauses',
    'Peaux',
    'Peintures',
    'Pelouses',
    'Pensions',
    'Perceptions',
    'Performances',
    'Personnes',
    'Perspectives',
    'Pertes',
    'Perturbations',
    'Peurs',
    'Philosophies',
    'Photographies',
    'Photos',
    'Phrases',
    'Pierres',
    'Piles',
    'Pilules',
    'Piscines',
    'Pistes',
    'Places',
    'Plages',
    'Plaintes',
    'Planches',
    'Plantes',
    'Plateformes',
    'Pluies',
    'Plumes',
    'Poches',
    'Pommes',
    'Pompes',
    'Populations',
    'Portes',
    'Portions',
    'Portes',
    'Positions',
    'Possessions',
    'Poudres',
    'Poursuites',
    'Poutres',
    'Pratiques',
    'Presses',
    'Pressions',
    'Preuves',
    'Primes',
    'Princesses',
    'Prises',
    'Prisons',
    'Privatisations',
    'Productrices',
    'Professionnelles',
    'Profondeurs',
    'Proies',
    'Projections',
    'Promenades',
    'Promesses',
    'Promotions',
    'Proportions',
    'Propositions',
    'Protections',
    'Provinces',
    'Provisions',
    'Publications',
    'Pubs',
    'Qualifications',
    'Questions',
    'Queues',
    'Racines',
    'Radios',
    'Raisons',
    'Rallonges',
    'Rebelles',
    'Recettes',
    'Recherches',
    'Recommandations',
    'Reconnaissances',
    'Reconstitutions',
    'Recrues',
    'Reines',
    'Relations',
    'Religions',
    'Remarques',
    'Remises',
    'Rencontres',
    'Reproches',
    'Respirations',
    'Ressources',
    'Restaurations',
    'Restrictions',
    'Retraites',
    'Richesses',
    'Rivales',
    'Robes',
    'Romances',
    'Roses',
    'Rotations',
    'Roues',
    'Routines',
    'Rues',
    'Ruines',
    'Rumeurs',
    'Saisons',
    'Salades',
    'Salles',
    'Salutations',
    'Sanctions',
    'Satisfactions',
    'Sauces',
    'Sauvegardes',
    'Savantes',
    'Sciences',
    'Sculptures',
    'Secondes',
    'Sections',
    'Semaines',
    'Sensations',
    'Serres',
    'Serrures',
    'Serviettes',
    'Signatures',
    'Significations',
    'Similitudes',
    'Simulations',
    'Situations',
    'Soldes',
    'Solutions',
    'Sommes',
    'Sondes',
    'Sorties',
    'Souches',
    'Souffrances',
    'Soupes',
    'Sources',
    'Spectatrices',
    'Statistiques',
    'Structures',
    'Substances',
    'Subventions',
    'Successions',
    'Suggestions',
    'Suppositions',
    'Surfaces',
    'Surprises',
    'Surtensions',
    'Surveillances',
    'Survivantes',
    'Suspectes',
    'Suspensions',
    'Tables',
    'Taches',
    'Tactiques',
    'Tailles',
    'Tasses',
    'Techniques',
    'Technologies',
    'Tendances',
    'Tensions',
    'Tentatives',
    'Tentes',
    'Tenues',
    'Terres',
    'Textures',
    'Tiges',
    'Toiles',
    'Toilettes',
    'Tomates',
    'Torsades',
    'Tortues',
    'Touches',
    'Traces',
    'Traditions',
    'Traductions',
    'Tranches',
    'Transactions',
    'Transcriptions',
    'Transformations',
    'Transitions',
    'Transmissions',
    'Tribues',
    'Troupes',
    'Trousses',
    'Urgences',
    'Usines',
    'Utilisatrices',
    'Vacances',
    'Vaches',
    'Vagues',
    'Valeurs',
    'Vapeurs',
    'Variables',
    'Variantes',
    'Veines',
    'Ventes',
    'Venues',
    'Vestes',
    'Veuves',
    'Viandes',
    'Victoires',
    'Vies',
    'Villageoises',
    'Villes',
    'Violences',
    'Vis',
    'Visions',
    'Vitamines',
    'Vitesses',
    'Voiles',
    'Voitures',
    'Vues',
    'Zones',
];
